import React, {FC} from "react"
import {Radio, CustomNodeRenderer} from "@irati/ui/src/FormItem"
import styled from "styled-components"
import {SavingOptionEnum} from "."

interface Props {
  type: SavingOptionEnum,
  name: string,
  label: string,
  isSelected: boolean,
  onSelect: (value: SavingOptionEnum) => any
}

const OptionWrapper = styled.div`
  display: flex;
  height: ${({theme}) => theme.spacing.six};
  border-radius: ${({theme}) => theme.spacing.half};
  padding-left: 20px;
  flex-direction: row;
  background-color: rgba(249, 120, 20, 0.05);
  align-items: center;
  margin-top: ${({theme}) => theme.spacing.one};
`

const OptionLabel = styled.div`
  font-weight: bold;
  color: ${({theme}) => theme.colors.greys.black}
`

const MobileSavingOption: FC<Props> = ({type, name, label, isSelected, onSelect}) => {
  const optionNodes = [
    {
      customNode: (
        <OptionLabel>{label}</OptionLabel>
      ),
      value: type,
      whiteSpace: "wrap"
    }
  ]

  return (
    <OptionWrapper>
      <Radio
        rowRenderer={CustomNodeRenderer}
        name={name}
        value={isSelected && type}
        options={optionNodes}
        onChange={() => onSelect(type)} />
    </OptionWrapper>
  )
}

export default MobileSavingOption
